let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dMlNz")).then(() => parcelRequire('jOpec'));